import {
  faEdit,
  faFilePdf,
  faMobile,
  faMobileAlt,
  faPencilAlt,
  faPeopleCarry,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useRef, useState } from "react";
import ContentLoader from "react-content-loader";
import { useDispatch, useSelector } from "react-redux";
import {
  getBillingShippingAddress,
  getClinicInformation,
  getCreditCards,
  getFullscriptStatus,
  getPersonalInformation,
  getPractitionerCommission,
  profilePostAction,
  uploadProfile,
} from "../../actions/profileAction";
import Avatar from "../../assets/images/default-avatar.jpg";
import BreadCrumb from "../../components/Breadcrumb";
import ImageButton from "../../components/ImageButton";
import ImageCropper from "../../components/ImageCropper";
import InfoItem from "../../components/InfoItem";
import { BUCKET_NAME, Domain_URL } from "../../constants/states";
import { getUserDetail, setFullScriptConnected } from "../../utils/helper";
import AddressListPopup from "./AddressListPopup";
import CardListPopup from "./CardListPopup";
import ChangeEmailPopup from "./ChangeEmailPopup";
import ClinicInformationPopup from "./ClinicInformationPopup";
import PersonalInformationPopup from "./PersonalInformationPopup";
import history from "../../utils/history";

import { getCreatePrescriptionPatients } from "../../actions/patientAction";
import CommissionPopup from "./CommissionPopup";
import RolePopup from "./RolePopup";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  acumaticaGetCustomerPaymentMethods,
  acumaticaGetCustomer,
  getCustomerById,
} from "../../actions/acumaticaAction";
import AddCustomer from "./AddCustomer";
import PaymentMethodProfiles from "./PaymentMethodProfiles";
import TwoFAModal from "../../components/TwoFAModal";
import AddressPopup from "./AddressPopup";
const Profile = () => {
  const role = useSelector((state) => state.role.role);
  const clinicInfo = useSelector((state) => state.profile.clinicInfo);
  const cardList = useSelector((state) => state.acumatica.paymentMethods);
  const addressList = useSelector((state) => state.profile.addressList);
  const userInfo = useSelector((state) => state.profile.userInfo);
  const customerInfo = useSelector((state) => state.acumatica.customerInfo);
  const commission = useSelector(
    (state) => state.profile.practitionerCommission
  );
  const customerByIdInfo = useSelector(
    (state) => state.acumatica.customerByIdInfo.contacts
  );
  const dispatch = useDispatch();
  const [showPersonalModal, setShowPersonalModal] = useState(false);
  const [showRoleModal, setShowRoleModal] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showShippingAddressModal, setShowShippingAddressModal] =
    useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showTwoFAModal, setShowTwoFAModal] = useState(false);
  const [showCommissionModal, setShowCommissionModal] = useState(false);
  const [showClinicModal, setShowClinicModal] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [showCustomerModal, setShowCustomerModal] = useState(null);
  const [showImageCropper, setShowImageCropper] = useState(false);
  const [uploadFile, getuploadFile] = useState(null);
  const [profileFile, setProfileFile] = useState(null);
  const [value, setValue] = useState(Math.random());
  const [isLoading, setIsLoading] = useState(true);
  const [isFullscriptConnected, setIsFullscriptConnected] = useState(false);
  const [selectedShippingAddress, setSelectedShippingAddress] = useState(null);

  useEffect(() => {
    dispatch(getClinicInformation());
    dispatch(getPractitionerCommission());
    dispatch(getBillingShippingAddress());
    dispatch(
      getPersonalInformation((userInfo) => {
        setIsLoading(false);
      })
    );
    dispatch(acumaticaGetCustomerPaymentMethods(getUserDetail()?.customerId));
    dispatch(getCustomerById(getUserDetail()?.customerId));
  }, [dispatch]);

  useEffect(() => {
    if (cardList.length > 0) {
      setSelectedCard(cardList[0]);
    } else {
      setSelectedCard(null);
    }
  }, [cardList]);

  useEffect(() => {
    if (addressList.length > 0) {
      setSelectedShippingAddress(addressList[0]);
    } else {
      setSelectedShippingAddress(null);
    }
  }, [addressList]);

  const disconnectFromFullscript = () => {
    var params = {
      params: {
        action: "revokeAccessToken",
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      profilePostAction(params, () => {
        setIsFullscriptConnected(false);
        setFullScriptConnected(false);
        dispatch(getCreatePrescriptionPatients());
      })
    );
  };

  return (
    <div className="profile-page">
      <BreadCrumb pageName={role && role.roleName} />

      <h3 className="page-title">User Profile</h3>
      {/* <AddressPopup /> */}
      {showPersonalModal && (
        <PersonalInformationPopup
          userInfo={userInfo}
          closePopup={() => setShowPersonalModal(false)}
        />
      )}
      {showRoleModal && (
        <RolePopup
          closePopup={() => setShowRoleModal(false)}
          agency={userInfo?.license_agency}
          id={userInfo?.license_id}
          description={userInfo?.license_description}
        />
      )}

      {showEmailModal && (
        <ChangeEmailPopup closePopup={() => setShowEmailModal(false)} />
      )}
      {showAddressModal && (
        <AddressPopup
          closePopup={() => setShowAddressModal(false)}
          addressInfo={customerByIdInfo.billingContact}
          fromBilling={true}
        />
      )}
      {showShippingAddressModal && (
        <AddressListPopup
          activeAddress={selectedShippingAddress}
          setActiveAddress={setSelectedShippingAddress}
          anotherActiveAddress={selectedAddress}
          setAnotherActiveAddress={setSelectedAddress}
          closePopup={() => setShowShippingAddressModal(false)}
          addressInfo={customerByIdInfo.shippingContact}
          fromBilling={false}
        />
      )}
      {showPaymentModal && (
        <PaymentMethodProfiles
          setActiveCard={setSelectedCard}
          activeCard={selectedCard}
          closePopup={() => setShowPaymentModal(false)}
        />
      )}
      {showClinicModal && (
        <ClinicInformationPopup
          clinicInfo={clinicInfo}
          setShowImageCropper={setShowImageCropper}
          closePopup={() => setShowClinicModal(false)}
          setValue={setValue}
        />
      )}

      {showCommissionModal && (
        <CommissionPopup
          commission={commission}
          closePopup={() => setShowCommissionModal(false)}
        />
      )}

      <p className="page-desc">Manage your profile and business information.</p>
      <div className="row">
        <div className="personal-section mt-3 col-md-6">
          <div className="d-flex align-items-center">
            <h5 className="profile-title">personal information</h5>
            <ImageButton
              text="Edit"
              icon={faEdit}
              style={{ position: "unset" }}
              onClick={() => setShowPersonalModal(true)}
            />
          </div>
          <hr className="separator" />

          <input
            accept="image/png, image/jpeg, image/jpg"
            type="file"
            id="input-file-upload"
            htmlFor="input-file-upload"
            multiple={false}
            onChange={(e) => {
              if (e.target.files[0]) {
                setProfileFile(e.currentTarget.files[0]);
                dispatch(uploadProfile(e.currentTarget.files[0]));
              }
            }}
          />
          <label type="file" id="label-file-upload" htmlFor="input-file-upload">
            <div>
              <div className="avatar">
                {console.log(profileFile)}
                <img
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "contain",
                  }}
                  src={
                    profileFile
                      ? URL.createObjectURL(profileFile)
                      : getUserDetail()?.hasProfilePicture
                        ? `https://storage.googleapis.com/${BUCKET_NAME}/user/${getUserDetail()?.id
                        }.png?${Math.random()}`
                        : Avatar
                  }
                  alt="user"
                />
                <div className="pencil-icon">
                  <FontAwesomeIcon icon={faPencilAlt} size="xs" />
                </div>
              </div>
            </div>
          </label>
          {!isLoading ? (
            <>
              <InfoItem
                title="Name"
                value={`${getUserDetail()?.firstName} ${getUserDetail()?.lastName
                  }`}
              />
              <div className="d-flex align-items-center">
                <InfoItem title="Email" value={userInfo && userInfo.email} />
                {role?.val != 4 ? (
                  <>
                    <ImageButton
                      style={{ position: "unset" }}
                      text="Change Email"
                      icon={faEdit}
                      onClick={() => setShowEmailModal(true)}
                    />
                  </>
                ) : (
                  ""
                )}
              </div>
              <InfoItem title="Phone" value={userInfo && userInfo.phone} />
              <InfoItem title="Street" value={userInfo && userInfo.address_1} />
              <InfoItem title="Apt" value={userInfo && userInfo.address_2} />
              <InfoItem title="City" value={userInfo && userInfo.city} />
              <InfoItem title="State" value={userInfo && userInfo.state} />
              <InfoItem title="Zip code" value={userInfo && userInfo.zip} />
              {(role?.val === 1 || role?.val === 6) && (
                <>
                  <div className="d-flex align-items-center mt-5">
                    <h5 className="profile-title">License information</h5>
                    {/* <ImageButton
                      text="Edit License"
                      icon={faEdit}
                      style={{ position: "unset" }}
                      onClick={() => setShowRoleModal(true)}
                    /> */}
                  </div>
                  <hr className="separator" />
                  <InfoItem
                    title="Issuing Body"
                    value={
                      userInfo && userInfo.license_agency == "OT"
                        ? "Other"
                        : userInfo.license_agency
                    }
                  />
                  <InfoItem
                    title="License Id"
                    value={userInfo && userInfo.license_id}
                  />

                  {userInfo && userInfo.license_agency == "OT" && (
                    <InfoItem
                      title="License Description"
                      value={userInfo.license_description}
                    />
                  )}
                  {userInfo && userInfo.file !== null && (
                    <img
                      onClick={() => {
                        window.open(userInfo.file, 'target = "_blank"');
                      }}
                      src={userInfo.file}
                      alt="license"
                      className="img-thumbnail"
                      style={{
                        height: "60px",
                        width: "200px",
                        objectFit: "contain",
                        cursor: "pointer",
                      }}
                    />
                  )}
                </>
              )}
            </>
          ) : (
            <ContentLoader
              speed={2}
              width={300}
              height={124}
              viewBox="0 0 300 124"
              backgroundColor="#f3f3f3"
              foregroundColor="#ffffff"
            >
              <rect x="4" y="13" rx="3" ry="3" width="410" height="6" />
              <rect x="4" y="29" rx="3" ry="3" width="380" height="6" />
              <rect x="4" y="45" rx="3" ry="3" width="178" height="6" />
              <rect x="4" y="59" rx="3" ry="3" width="410" height="6" />
              <rect x="4" y="75" rx="3" ry="3" width="380" height="6" />
              <rect x="4" y="91" rx="3" ry="3" width="178" height="6" />
            </ContentLoader>
          )}
          {role?.val == 4 ? (
            <>
              <div className="d-flex align-items-center mt-5">
                <h5 className="profile-title ">Switch Role</h5>
                <ImageButton
                  icon={faUser}
                  text="Become practitioner"
                  style={{ position: "unset" }}
                  onClick={() => setShowRoleModal(true)}
                />
              </div>
              <hr className="separator" />
            </>
          ) : (
            ""
          )}
          {role?.val === 1 || role?.val === 6 ? (
            <>
              <div className="d-flex align-items-center mt-5">
                <h5 className="profile-title ">Commission information</h5>
                <ImageButton
                  text={commission ? "Edit" : "Add"}
                  icon={faEdit}
                  style={{ position: "unset" }}
                  onClick={() => setShowCommissionModal(true)}
                />
              </div>
              <hr className="separator" />

              <InfoItem
                title="Default Commission"
                value={commission ? `${commission}%` : ""}
              />
            </>
          ) : (
            ""
          )}

          {isFullscriptConnected && (
            <>
              <div className="d-flex align-items-center mt-5">
                <h5 className="profile-title ">Fullscript</h5>
                <button
                  className="btn btn-orange ml-3"
                  onClick={disconnectFromFullscript}
                >
                  Disconnect From Fullscript
                </button>
              </div>
              <hr className="separator" />
            </>
          )}
        </div>
        {showCustomerModal && (
          <AddCustomer
            customerInfo={customerInfo}
            closePopup={() => setShowCustomerModal(false)}
          />
        )}
        <div className="personal-section mt-3 col-md-6">
          <div className="d-flex align-items-center ">
            <h5 className="profile-title ">Two Factor Authentication</h5>
            <ImageButton
              text="setup"
              icon={faMobileAlt}
              style={{ position: "unset" }}
              onClick={() => setShowTwoFAModal(true)}
            />
          </div>
          {showTwoFAModal && (
            <TwoFAModal closePopup={() => setShowTwoFAModal(false)} />
          )}
          <hr className="separator" />
          <div className="row mt-2 info-item">
            <div className="col-md-12">
              <div className="d-flex align-items-center ">
                <h5 className="profile-title">Billing / Shipping Address</h5>
                <ImageButton
                  text="edit"
                  icon={faEdit}
                  style={{ position: "unset" }}
                  onClick={() => setShowShippingAddressModal(true)}
                />
              </div>
              <hr className="separator" />
              {selectedShippingAddress && (
                <p className="info-value">
                  {selectedShippingAddress?.first_name}{" "}
                  {selectedShippingAddress?.last_name}
                  <br />
                  {selectedShippingAddress?.address_1}
                  {", "}
                  {selectedShippingAddress?.address_2 &&
                    `Apt ${selectedShippingAddress?.address_2},`}{" "}
                  {selectedShippingAddress?.city},{" "}
                  {selectedShippingAddress?.state}{" "}
                  {selectedShippingAddress?.zip}
                </p>
              )}
            </div>
          </div>
          {/* <div className="row mt-2 info-item">
            <div className="col-md-12">
              <div className="d-flex align-items-center ">
                <h5 className="profile-title">Billing Address</h5>
                <ImageButton
                  text="edit"
                  icon={faEdit}
                  style={{ position: "unset" }}
                  onClick={() => setShowAddressModal(true)}
                />
              </div>
              <hr className="separator" />

              {customerByIdInfo?.billingContact && (
                <p className="info-value">
                  {customerByIdInfo?.billingContact?.address_1}
                  {", "}
                  {customerByIdInfo?.billingContact?.address_2 &&
                    `Apt ${customerByIdInfo?.billingContact?.address_2},`}{" "}
                  {customerByIdInfo?.billingContact?.city},{" "}
                  {customerByIdInfo?.billingContact?.state}{" "}
                  {customerByIdInfo?.billingContact?.zip}
                </p>
              )}
            </div>
          </div> */}
          <div className="row mt-2 info-item">
            <div className="col-md-12">
              <div className="d-flex align-items-center ">
                <h5 className="profile-title ">Payment Methods</h5>
                <ImageButton
                  text="edit"
                  icon={faEdit}
                  style={{ position: "unset" }}
                  onClick={() => setShowPaymentModal(true)}
                />
              </div>
              <hr className="separator" />
              {selectedCard && (
                <p className="info-value">
                  {selectedCard?.AccountHolderName} {selectedCard?.CardNumber}{" "}
                  Exp: {selectedCard?.CardExpiration}
                </p>
              )}
            </div>
          </div>
          {role?.val === 1 || role?.val === 6 ? (
            <>
              <div className="d-flex align-items-center  mt-5">
                <h5 className="profile-title">Clinic information</h5>
                <ImageButton
                  text={clinicInfo?.clinicId ? "Edit" : "Add"}
                  icon={faEdit}
                  style={{ position: "unset" }}
                  onClick={() => setShowClinicModal(true)}
                />
              </div>
              <hr className="separator" />
            </>
          ) : (
            ""
          )}
          {clinicInfo && (role?.val === 1 || role?.val === 6) && (
            <>
              <div className="d-flex align-items-center mt-5">
                <InfoItem title="Logo" />
                {clinicInfo?.hasLogo && (
                  <>
                    <img
                      src={`https://storage.googleapis.com/${BUCKET_NAME}/clinic/${clinicInfo?.clinicId
                        }_logo.png?+${Math.random()}`}
                      alt="logo"
                      className="img-thumbnail"
                      style={{
                        height: "60px",
                        width: "200px",
                        objectFit: "contain",
                      }}
                    />
                    <a
                      target={clinicInfo.hasLogo ? "_blank" : ""}
                      href={
                        clinicInfo.hasLogo
                          ? `${Domain_URL}api/clinicLogo?clinic_id=${clinicInfo.clinicId
                          }&token=${getUserDetail()?.token}`
                          : "javascript:void(0)"
                      }
                    >
                      <ImageButton
                        style={{ position: "unset" }}
                        disabled={clinicInfo.hasLogo}
                        text="Preview Bottle label"
                        icon={faFilePdf}
                      />
                    </a>
                  </>
                )}
              </div>

              <p
                className=" mt-5 mb-2 test-label"
                onClick={() => setShowImageCropper(true)}
              >
                Upload Clinic Logo
              </p>
              <div className="color-wrapper">
                <InfoItem title="Color Scheme" />
                <div className="color-box">
                  Headings{" "}
                  <div
                    className="color"
                    style={{ backgroundColor: clinicInfo.color_headings }}
                  />
                  Values
                  <div
                    className="color"
                    style={{ backgroundColor: clinicInfo.color_value }}
                  />
                </div>
              </div>
              <InfoItem
                title="Clinic Name"
                value={clinicInfo && clinicInfo.clinicname}
              />
              <InfoItem
                title="Website"
                value={clinicInfo && clinicInfo.website}
              />
              <InfoItem title="Email" value={clinicInfo && clinicInfo.email} />
              <InfoItem
                title="Phone"
                value={clinicInfo && clinicInfo.phone_1}
              />
              <InfoItem
                title="Secondary Phone"
                value={clinicInfo && clinicInfo.phone_2}
              />
              <InfoItem
                title="Street"
                value={clinicInfo && clinicInfo.address_1}
              />
              <InfoItem
                title="Apt"
                value={clinicInfo && clinicInfo.address_2}
              />
              <InfoItem title="City" value={clinicInfo && clinicInfo.city} />
              <InfoItem title="State" value={clinicInfo && clinicInfo.state} />

              <InfoItem title="Zip code" value={clinicInfo && clinicInfo.zip} />
              {showImageCropper && (
                <ImageCropper
                  closePopup={() => setShowImageCropper(false)}
                  clinicId={clinicInfo && clinicInfo.clinicId}
                  setValue={setValue}
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default Profile;
